export const scrollToOffer = (
  e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
) => {
  e.preventDefault()
  const offerSection = document.getElementById('oferta')
  if (offerSection) {
    offerSection.scrollIntoView({ behavior: 'smooth' })
  }
}
